import { useEffect } from 'react';
import { useCompanyQuery } from './useCompanyQuery';

interface usePageTitleProps {
  title?: string;
  isClientPortal?: boolean;
}

export const usePageTitle = ({ title, isClientPortal = false }: usePageTitleProps) => {
  const appVariant = isClientPortal ? 'Portal' : 'TMS';
  const companyQuery = useCompanyQuery();
  const userInfo = companyQuery.data;

  const newTitle = title
    ? `${title} | ${appVariant} - ${userInfo?.name}`
    : `${appVariant} - ${userInfo?.name}`;
  document.title = newTitle;

  // Cleanup function to reset the title when the component is unmounted
  useEffect(() => {
    return () => {
      if (userInfo?.name) document.title = `${appVariant} - ${userInfo.name}`;
      else document.title = appVariant;
    };
  }, []);
};
